<template functional>
  <div>
    <div
      v-for="(warehouse, index) in props.item.warehouses"
      :key="index"
      class="cname"
    >
      <a :data-action="'showCompany'" :data-company-id="warehouse.id">
        {{ warehouse.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "drayage-warehouse-name",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
